import { AUTHORIZATION_HEADER } from '../../../../../../../src/authorization';
import { send } from '../../../../../../../src/network';
import {
  OrderGroupingStatus,
  type OrderDetail,
  type OrderReady,
  type OrderShuffling,
} from '../../../../../../../src/types/OrderDetail';
export { StatusEnum as OrderStatus } from '../../../../../../../src/types/StatusEnum';
export { type Product } from '../../../../../../../src/types/Product';
export {
  OrderGroupingStatus,
  type OrderDetail,
  type OrderReady,
  type OrderShuffling,
};

type Params = {
  orderId: number;
};

export async function getCustomerOrder({ orderId }: Params) {
  return await send<OrderDetail>({
    path: `/api/v2/customers/self/orders/${orderId}`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
